// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"info-tip_wrapper__pC2GM","trigger":"info-tip_trigger__eNA8c","bubble":"info-tip_bubble__rnegR","open":"info-tip_open__ZmlxE"};